import { Trip } from './../';
import { Status } from './../enums/status';

export class Carrier {
  id: number;

  userData: {
    favorited: boolean,
    note: string
  };

  imo: string;
  name: string;
  description: string;

  // schedules
  iconUrl: string;

  // profile
  established: string;
  year_est: string;
  carrier_group: string;
  max_ships: string;
  max_teu: string;
  kind: string;
  regions: string;
  scac: string;
  smdg: string;
  bic: string;
  notice: string;

  // headquarters
  company: string;
  address: string;
  city: string;
  countryId: string;
  countryName: string;
  postcode: string;
  website: string;

  email: string;
  // fax: string;
  // phone: string;

  viewDetails: boolean;

  // summary information
  selected: boolean;
  count: number;
  minDuration: number;
  minTranshipments: number;
  minDurationTranshipments: string;

  maxDuration: number;
  reliability: string;

  // performance data
  status: Status;
  trips: Array<Trip>;

  constructor(json: any, accountType = '') {
    try {
      this.id = json.id || 0;
      this.imo = json.imo || '';
      this.name = json.name || '';
      this.description = json.description || '';

      this.userData = json.userData || {
        favorited: false,
        note: ''
      };

      this.iconUrl = '../img/carriers/' + this.id + '.gif';
    } catch (ex) {
      this.setDefaults();
    }

    this.setSummaryDefaults();
    this.setProfile(json, accountType);
    this.setHeadquarters(json, accountType);

    //Title Case for Category ("kind")
    if(this.kind === "deepsea") {
      this.kind = "Deep Sea"
   }
   if(this.kind === "shortsea") {
     this.kind = "Short Sea"
   }
   if(this.kind === "feeder") {
     this.kind = "Feeder"
   }
   if(this.kind === "roro") {
     this.kind = "Ro-Ro"
   }
   if(this.kind === "nvocc") {
     this.kind = "NVOCC"
   }
   if(this.kind === "unknown") {
     this.kind = "Unknown"
   }
  }

  setDefaults() {
    this.id = 0;
    this.imo = '';
    this.name = '';
    this.description = '';
    this.userData = {
      favorited: false,
      note: ''
    };
    this.iconUrl = '../img/carriers/0.gif';
  }

  setSummary(json: any, isSelected: boolean) {
    try {
      this.viewDetails = false;
      this.selected = isSelected;
      this.count = json.count;
      this.minDuration = json.min_duration;
      this.minTranshipments = json.min_duration_ts_count;
      this.minDurationTranshipments = json.min_duration_ts_count == 0 ? 'direct' : (json.min_duration_ts_count).toString() + ' t/s';
      this.maxDuration = json.max_duration;
      this.reliability = 'blurred text';
    } catch (ex) {
      this.setSummaryDefaults();
    }
  }

  setSummaryDefaults() {
    this.viewDetails = false;
    this.selected = true;
    this.count = 0;
    this.minDuration = 0;
    this.maxDuration = 0;
    this.reliability = 'blurred text';
  }

  setProfile(json: any, accountType: string) {
    let show = true;
    try {
      this.established = json.established;
      this.year_est = json.year_est;
      this.carrier_group = json.carrier_group;
      this.max_ships = json.max_ships + ' ships';
      this.max_teu = json.max_teu + ' TEU';
      this.kind = json.kind;
      this.regions = json.regions;
      this.scac = json.scac;
      this.smdg = json.smdg;
      this.bic = json.bic;
      this.notice = json.notice;
    } catch (ex) {
      this.setProfileDefaults();
    }
  }

  setProfileDefaults() {
    this.established = '';
    this.year_est = '';
    this.carrier_group = '';
    this.max_ships = '';
    this.max_teu = '';
    this.kind = '';
    this.regions = '';
    this.scac = '';
    this.smdg = '';
    this.bic = '';
    this.notice = '';
  }

  setHeadquarters(json: any, accountType: string) {
    let show = true;
    try {
      this.company = json.company;
      this.address = json.address;
      this.city = json.city;

      if (json.country !== undefined) {
        this.countryId = json.country.id;
        this.countryName = json.country.name;
      } else {
        this.countryId = '';
        this.countryName = '';
      }

      this.postcode = json.postcode;
      this.website = json.website;
      this.email = json.email;
    } catch (ex) {
      this.setHeadquartersDefaults();
    }
  }

  setHeadquartersDefaults() {
    this.company = '';
    this.address = '';
    this.city = '';
    this.countryId = '';
    this.countryName = '';
    this.postcode = '';
    this.website = '';
    this.email = '';
  }

  setTrips(trips: Array<Trip>) {
    this.trips = trips;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/models/carrier.ts